import { plPL } from '@mui/x-date-pickers/locales';

// Polish UI text for MUI X date/time pickers (toolbar, clear/cancel/today labels,
// field placeholders, validation strings, etc.). Pass to every
// <LocalizationProvider> via `localeText={plDatePickerLocaleText}` so picker chrome
// is Polish, not the MUI default English. `adapterLocale={pl}` only localizes date
// formatting — it does NOT translate this UI text.
export const plDatePickerLocaleText =
  plPL.components.MuiLocalizationProvider.defaultProps.localeText;
